var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcEjectRotor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1418 29.7122L15.7434 25.5614C10.4744 27.3365 7.54869 30.1161 6.10823 34.5479C5.46474 29.1298 6.70402 23.0985 13.7321 19.5911L12.372 15.5541L22.335 20.0696L17.1418 29.7122Z",
    fill: "#003E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 11C25.4477 11 25 11.4477 25 12C25 12.5523 25.4477 13 26 13H27V29L30.5 27H34.75L38 29V13H39C39.5523 13 40 12.5523 40 12C40 11.4477 39.5523 11 39 11H26Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcEjectRotor);
export default __webpack_public_path__ + "static/media/mc_eject_rotor.24031a1e667e6dd9f68caf2755cad18c.svg";
export { ForwardRef as ReactComponent };